<template>
  <div
    class="tw:flex tw:gap-2 tw:py-2 tw:flex-col"
  >
    <slot />
  </div>
</template>

<script setup>
</script>
